import { useStore } from 'hooks/useStore';
import {
  allOptionsInterfaceBultEdit,
  NDCBulkEditFormFields,
  NDCBulkEditFormFieldsTypes,
  NDCFormBulkEditArrayFieldInteface,
  NDCFormFieldsTypes,
} from 'Interfaces/FactsInterfaces/drugInterfaces';
import {
  ndcHistoryRequestPayloadInterface,
  ndcPpsPpsReasonUpdateRequestInterface,
  ndcSegmentationDpStrategyUpdateRequestInterface,
} from 'Interfaces/FactsInterfaces/ndcInterfaces';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { factScreenServices } from 'services/factsScreenServices';
import { DateConversionUtility, getFirstDayOfMonth, getLastDayOfMonth } from 'utils/dateUtilities';
import { deepCopy } from 'utils/deepCopy';
import {
  checkIfFunctionalityEnabled,
  checkIfNDCStrategyAddEnabled,
} from 'utils/facts/roleBasedFunctionalityAccess';
import {
  convertNdcFormDataToAllOptionsBultEdit,
  createEmptyFieldObject,
  createNdcPopUpDataForBulkEdit,
  selectedOptionUtilityBultEdit,
} from '../../utils/utilities';
import { handleCheckErrorForNdcBulkEdit } from './utils/validateFormSubmit';

export const useBultEditModal = () => {
  const {
    UserStore: { userModulesRoles },
    FactsStore: {
      ndcFormDropDownData,
      rowDataForSelectedNdcSectionByContractNumber,
      selectedNdcStrategyIndexesForEdit,
      ndcHistoryData,
      setNdcHistoryData,
      toggleNdcBulkEditStrategyModal,
    },
  } = useStore();
  const [initialNdcStrategyIndividualEditData, setInitialNdcStrategyIndividualEditData] =
    useState<NDCBulkEditFormFields | null>(createNdcPopUpDataForBulkEdit());
  const [ndcStrategyIndividualEditData, setNdcStrategyIndividualEditData] =
    useState<NDCBulkEditFormFields | null>(createNdcPopUpDataForBulkEdit());
  const [allFieldsOptions, setAllFieldsOptions] = useState<allOptionsInterfaceBultEdit | null>({
    PPS: [],
    PPSSC: [],
    Segmentation: [],
    DPStrategy: [],
  });
  const [isNdcUpdating, setIsNdcUpdating] = useState(false);
  const [errorDetails, setErrorDetails] = useState({ isError: false, errorDetails: '' });
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);

  const allDropdownOptions = () => {
    const tempFormFields: { name: string; code: NDCFormFieldsTypes }[] = [];
    if (ndcStrategyIndividualEditData) {
      for (const [key, value] of Object.entries(ndcStrategyIndividualEditData)) {
        if (!value.selected) {
          if (key === 'PPSSC') {
            // PPSSC handled with PPS
          } else if (key === 'PPS')
            tempFormFields.push({ name: 'PPS Strategy & Reason', code: key as NDCFormFieldsTypes });
          else {
            tempFormFields.push({ name: value.fieldName, code: key as NDCFormFieldsTypes });
          }
        }
      }
    }
    return tempFormFields;
  };
  const [allOptions, setAllOptions] = useState(allDropdownOptions());

  const formUpdateMethods = {
    handleFieldChange: (
      fieldName: NDCBulkEditFormFieldsTypes,
      currentFieldName: NDCBulkEditFormFieldsTypes
    ) => {
      if (ndcStrategyIndividualEditData) {
        const tempNdcEditData = deepCopy(ndcStrategyIndividualEditData);
        tempNdcEditData[fieldName] = { ...createEmptyFieldObject(currentFieldName) };
        tempNdcEditData[fieldName].selected = true;
        tempNdcEditData[fieldName].startDate = tempNdcEditData[currentFieldName].startDate;
        tempNdcEditData[fieldName].endDate = tempNdcEditData[currentFieldName].endDate;
        tempNdcEditData[currentFieldName] = createEmptyFieldObject(currentFieldName);
        setNdcStrategyIndividualEditData(tempNdcEditData);
      }
    },

    handleUpdateValue: (fieldName: NDCBulkEditFormFieldsTypes, value: string) => {
      if (ndcStrategyIndividualEditData) {
        const tempNdcEditData = deepCopy(ndcStrategyIndividualEditData);
        tempNdcEditData[fieldName].value = value;
        setNdcStrategyIndividualEditData(tempNdcEditData);
      }
    },
    handleUpdateStartDate: (fieldName: NDCFormFieldsTypes, newStartDate: Date) => {
      if (ndcStrategyIndividualEditData) {
        const tempNdcEditData = deepCopy(ndcStrategyIndividualEditData);
        tempNdcEditData[fieldName].startDate =
          DateConversionUtility.convertLocalToDBDateString(newStartDate);
        if (fieldName === 'PPS') {
          tempNdcEditData['PPSSC'].startDate =
            DateConversionUtility.convertLocalToDBDateString(newStartDate);
        }
        if (fieldName === 'DPStrategy' || fieldName === 'Segmentation') {
          tempNdcEditData[fieldName].startDate = DateConversionUtility.convertLocalToDBDateString(
            getFirstDayOfMonth(newStartDate.toDateString())
          );
        }
        setNdcStrategyIndividualEditData(tempNdcEditData);
      }
    },
    handleUpdateEndDate: (fieldName: NDCFormFieldsTypes, newStartDate: Date) => {
      if (ndcStrategyIndividualEditData) {
        const tempNdcEditData = deepCopy(ndcStrategyIndividualEditData);
        tempNdcEditData[fieldName].endDate =
          DateConversionUtility.convertLocalToDBDateString(newStartDate);
        if (fieldName === 'PPS') {
          tempNdcEditData['PPSSC'].endDate =
            DateConversionUtility.convertLocalToDBDateString(newStartDate);
        }
        if (fieldName === 'DPStrategy' || fieldName === 'Segmentation') {
          // tempNdcEditData[fieldName].endDate = getLastDayOfMonth(formatDate(newStartDate.toDateString())).toDateString();
          tempNdcEditData[fieldName].endDate = DateConversionUtility.convertLocalToDBDateString(
            getLastDayOfMonth(newStartDate.toDateString())
          );
        }
        setNdcStrategyIndividualEditData(tempNdcEditData);
      }
    },
    handleCheckError: () => {
      if (ndcStrategyIndividualEditData?.PPS.selected) {
        if (
          !ndcStrategyIndividualEditData.PPS.startDate ||
          !ndcStrategyIndividualEditData.PPS.endDate
        ) {
          setErrorDetails({
            isError: true,
            errorDetails: 'Start date and end date cannot be left empty for PPS',
          });
          return true;
        } else if (!ndcStrategyIndividualEditData.PPS.value) {
          setErrorDetails({ isError: true, errorDetails: 'Value for pps is required' });
          return true;
        }
      }
      if (ndcStrategyIndividualEditData?.PPSSC.selected) {
        if (
          ndcStrategyIndividualEditData.PPSSC.startDate ===
            initialNdcStrategyIndividualEditData?.PPSSC.startDate &&
          ndcStrategyIndividualEditData.PPSSC.endDate ===
            initialNdcStrategyIndividualEditData?.PPSSC.endDate
        ) {
          setErrorDetails({
            isError: true,
            errorDetails:
              'None of start date or end changed for PPSSC, at least one date change required',
          });
          return true;
        } else if (!ndcStrategyIndividualEditData.PPSSC.value) {
          setErrorDetails({ isError: true, errorDetails: 'Value for PPSC is required' });
          return true;
        }
      }
      if (ndcStrategyIndividualEditData?.Segmentation.selected) {
        if (
          ndcStrategyIndividualEditData.Segmentation.startDate ===
            initialNdcStrategyIndividualEditData?.Segmentation.startDate &&
          ndcStrategyIndividualEditData.Segmentation.endDate ===
            initialNdcStrategyIndividualEditData?.Segmentation.endDate
        ) {
          setErrorDetails({
            isError: true,
            errorDetails:
              'None of start date or end changed for Segmentation, at least one date change required',
          });
          return true;
        } else if (!ndcStrategyIndividualEditData.Segmentation.value) {
          setErrorDetails({ isError: true, errorDetails: 'Value for Segmentation is required' });
          return true;
        }
      }
      if (ndcStrategyIndividualEditData?.DPStrategy.selected) {
        if (
          ndcStrategyIndividualEditData.DPStrategy.startDate ===
            initialNdcStrategyIndividualEditData?.DPStrategy.startDate &&
          ndcStrategyIndividualEditData.DPStrategy.endDate ===
            initialNdcStrategyIndividualEditData?.DPStrategy.endDate
        ) {
          setErrorDetails({
            isError: true,
            errorDetails:
              'None of start date or end changed for DP Strategy, at least one date change required',
          });
          return true;
        } else if (!ndcStrategyIndividualEditData.DPStrategy.value) {
          setErrorDetails({ isError: true, errorDetails: 'Value for DP Strategy is required' });
          return true;
        }
      }
      return false;
    },
    handleUpdateButtonClick: async () => {
      if (ndcStrategyIndividualEditData && initialNdcStrategyIndividualEditData && ndcHistoryData) {
        if (
          handleCheckErrorForNdcBulkEdit({
            ndcStrategyIndividualEditData,
            initialNdcStrategyIndividualEditData,
            setErrorDetails,
            userRoles: userModulesRoles.facts,
            checkIfFunctionalityEnabled: checkIfFunctionalityEnabled,
            futureNdcData: ndcHistoryData,
            userModulesRoles,
          })
        ) {
          return;
        }
        const paydloadPpsPpsReason: ndcPpsPpsReasonUpdateRequestInterface[] = [];
        const payloadSegmentationDPStrategy: ndcSegmentationDpStrategyUpdateRequestInterface[] = [];

        selectedNdcStrategyIndexesForEdit.forEach((index: number) => {
          const selectedNdcRowData = rowDataForSelectedNdcSectionByContractNumber(index);

          if (selectedNdcRowData !== null) {
            let tempPricingStrategyId = 0;
            ndcFormDropDownData?.PPSDescriptions.forEach(option => {
              if (option.PricingStrategyDescription === ndcStrategyIndividualEditData?.PPS.value) {
                tempPricingStrategyId = option.PricingStrategyId;
              }
            });
            let tempPricingStrategyReasonId = 0;
            ndcFormDropDownData?.PPSReasons.forEach(option => {
              if (option.Reason === ndcStrategyIndividualEditData?.PPSSC.value) {
                tempPricingStrategyReasonId = option.ReasonID;
              }
            });

            let tempReportingSegmentId = 0;
            ndcFormDropDownData?.ReportingSegments.forEach(option => {
              if (
                option.ReportingSegmentName === ndcStrategyIndividualEditData?.Segmentation.value
              ) {
                tempReportingSegmentId = option.ReportingSegmentID;
              }
            });

            let tempReportingDPStrategyId = 0;
            ndcFormDropDownData?.DpStrategies.forEach(option => {
              if (option.ReportingSegmentName === ndcStrategyIndividualEditData?.DPStrategy.value) {
                tempReportingDPStrategyId = option.ReportingSegmentID;
              }
            });

            if (
              ndcStrategyIndividualEditData?.PPS.selected &&
              ndcStrategyIndividualEditData?.PPSSC.selected
            )
              paydloadPpsPpsReason.push({
                pk: selectedNdcRowData?.PricingStrategyComponentID,
                NDC11: selectedNdcRowData.NDC11,
                PricingStrategyId: tempPricingStrategyId,
                PricingStrategyReasonId: tempPricingStrategyReasonId,
                StartDate: ndcStrategyIndividualEditData?.PPS.startDate || '',
                EndDate: ndcStrategyIndividualEditData?.PPS.endDate || '',
              });
            if (ndcStrategyIndividualEditData?.Segmentation.selected)
              payloadSegmentationDPStrategy.push({
                pk: selectedNdcRowData?.SegmentationID,
                NDC11: selectedNdcRowData.NDC11,
                ReportingSegmentID: tempReportingSegmentId,
                StartDate: ndcStrategyIndividualEditData?.Segmentation.startDate || '',
                EndDate: ndcStrategyIndividualEditData?.Segmentation.endDate || '',
              });

            if (ndcStrategyIndividualEditData?.DPStrategy.selected)
              payloadSegmentationDPStrategy.push({
                pk: selectedNdcRowData?.DPstratergyID,
                NDC11: selectedNdcRowData.NDC11,
                ReportingSegmentID: tempReportingDPStrategyId,
                StartDate: ndcStrategyIndividualEditData?.DPStrategy.startDate || '',
                EndDate: ndcStrategyIndividualEditData?.DPStrategy.endDate || '',
              });
          }
        });

        try {
          setIsNdcUpdating(true);
          setErrorDetails({ isError: false, errorDetails: '' });
          let updateMsg = '';
          if (
            ndcStrategyIndividualEditData?.PPS.selected ||
            ndcStrategyIndividualEditData?.PPSSC.selected ||
            ndcStrategyIndividualEditData?.Segmentation.selected ||
            ndcStrategyIndividualEditData?.DPStrategy.selected
          ) {
            await factScreenServices.updateNdcPpsPpscInfo({
              ppsPpsReason: paydloadPpsPpsReason,
              segmentationDpStrategy: payloadSegmentationDPStrategy,
            });
          }

          if (ndcStrategyIndividualEditData.PPS.selected)
            // toast.success("Successfully Updated PPS, PPS Reason");
            updateMsg += 'PPS, PPS Reason';

          if (ndcStrategyIndividualEditData.Segmentation.selected)
            updateMsg += updateMsg ? ', Financial Segmentation' : 'Financial Segmentation';

          if (ndcStrategyIndividualEditData.DPStrategy.selected)
            updateMsg += updateMsg ? ', Demand Planning' : 'Demand Planning';

          toast.success(`Successfully Added future ${updateMsg}`);
          toggleNdcBulkEditStrategyModal();
        } catch (_err) {
          toast.error('NDC updation failed, please try again');
        } finally {
          setIsNdcUpdating(false);
        }
      }
    },
  };

  const checkIfDropdownOptionDisabled = (option: { code: string; name: string }) => {
    return checkIfNDCStrategyAddEnabled(
      option.code as NDCFormFieldsTypes,
      userModulesRoles.facts,
      userModulesRoles
    )
      ? false
      : true;
  };

  const formFieldsArrayConverter = () => {
    const tempFormFields: NDCFormBulkEditArrayFieldInteface[] = [];
    if (ndcStrategyIndividualEditData) {
      for (const [key, value] of Object.entries(ndcStrategyIndividualEditData)) {
        if (value.selected)
          tempFormFields.push({ keyName: key as NDCBulkEditFormFieldsTypes, ...value });
      }
    }
    return tempFormFields;
  };

  const handleFieldAdd = () => {
    if (ndcStrategyIndividualEditData) {
      const tempNdcData = deepCopy(ndcStrategyIndividualEditData);
      // tempNdcData.Unassigned.selected = true;
      setNdcStrategyIndividualEditData(tempNdcData);
    }
  };

  const isUpdateDisable = () => {
    // if (ndcStrategyIndividualEditData && ndcStrategyIndividualEditData.Unassigned.selected) {
    //     return true;
    // }
    // if (ndcStrategyIndividualEditData && !ndcStrategyIndividualEditData.Segmentation.selected && !ndcStrategyIndividualEditData.DPStrategy.selected && !ndcStrategyIndividualEditData.PPSSC.selected && !ndcStrategyIndividualEditData.PPS.selected && !ndcStrategyIndividualEditData.Unassigned.selected) {
    //     return true;
    // }
    return false;
  };

  const nonSelectedFields = (selectedOptionName: NDCBulkEditFormFieldsTypes) => {
    const tempFormFields: { name: string; code: NDCBulkEditFormFieldsTypes }[] = [];
    if (ndcStrategyIndividualEditData) {
      allOptions.forEach(option => {
        if (
          ndcStrategyIndividualEditData[option.code].selected === false ||
          option.code === selectedOptionName
        ) {
          tempFormFields.push(option);
        }
      });
    }
    return tempFormFields;
  };

  const removeField = (fieldName: NDCBulkEditFormFieldsTypes) => {
    if (ndcStrategyIndividualEditData) {
      const tempNdcData = deepCopy(ndcStrategyIndividualEditData);
      tempNdcData[fieldName] = createEmptyFieldObject(fieldName);
      if (fieldName === 'PPS' || fieldName === 'PPSSC') {
        tempNdcData.PPS.selected = false;
        tempNdcData.PPSSC.selected = false;
      }
      setNdcStrategyIndividualEditData(tempNdcData);
    }
  };

  const selectedOption = (fieldName: NDCBulkEditFormFieldsTypes) => {
    if (allOptions.length > 0) {
      let option: { name: string; code: NDCFormFieldsTypes } | null = null;
      allOptions.forEach(currOption => {
        if (currOption.code == fieldName) {
          option = currOption;
        }
      });
      return option;
    }
  };

  const maxDateFromGivenAndTodays = (givenDate: Date) => {
    const date = new Date();
    if (givenDate > date) {
      return givenDate;
    } else {
      return date;
    }
  };

  const handleStrategySelect = (strategyName: NDCFormFieldsTypes) => {
    if (ndcStrategyIndividualEditData && initialNdcStrategyIndividualEditData) {
      const tempNDCData = deepCopy(ndcStrategyIndividualEditData);
      tempNDCData[strategyName].selected = true;
      if (strategyName === 'PPS' || strategyName === 'PPSSC') {
        tempNDCData['PPS'].selected = true;
        tempNDCData['PPSSC'].selected = true;
      }
      setNdcStrategyIndividualEditData(tempNDCData);

      const tempInitialNDCData = deepCopy(initialNdcStrategyIndividualEditData);
      tempInitialNDCData[strategyName].selected = true;
      if (strategyName === 'PPS' || strategyName === 'PPSSC') {
        tempInitialNDCData['PPS'].selected = true;
        tempInitialNDCData['PPSSC'].selected = true;
      }
      setInitialNdcStrategyIndividualEditData(tempInitialNDCData);

      const tempFormFields: { name: string; code: NDCFormFieldsTypes }[] = [];
      for (const [key, value] of Object.entries(ndcStrategyIndividualEditData)) {
        if (!value.selected)
          tempFormFields.push({ name: value.fieldName, code: key as NDCFormFieldsTypes });
      }
      setAllOptions(tempFormFields);
    }
  };

  const handleUnselectStrategy = (strategyName: NDCFormFieldsTypes) => {
    if (ndcStrategyIndividualEditData && initialNdcStrategyIndividualEditData) {
      const tempNDCData = deepCopy(ndcStrategyIndividualEditData);
      tempNDCData[strategyName].selected = false;
      if (strategyName === 'PPS' || strategyName === 'PPSSC') {
        tempNDCData['PPS'].selected = false;
        tempNDCData['PPSSC'].selected = false;
      }
      setNdcStrategyIndividualEditData(tempNDCData);

      const tempInitialNDCData = deepCopy(initialNdcStrategyIndividualEditData);
      tempInitialNDCData[strategyName].selected = false;
      if (strategyName === 'PPS' || strategyName === 'PPSSC') {
        tempInitialNDCData['PPS'].selected = false;
        tempInitialNDCData['PPSSC'].selected = false;
      }
      setInitialNdcStrategyIndividualEditData(tempInitialNDCData);

      const tempFormFields: { name: string; code: NDCFormFieldsTypes }[] = [];
      for (const [key, value] of Object.entries(ndcStrategyIndividualEditData)) {
        if (!value.selected)
          tempFormFields.push({ name: value.fieldName, code: key as NDCFormFieldsTypes });
      }
      setAllOptions(tempFormFields);
    }
  };

  const isAnyStrategySelected = () => {
    let flag = false;
    if (ndcStrategyIndividualEditData) {
      for (const [_key, value] of Object.entries(ndcStrategyIndividualEditData)) {
        if (value.selected) flag = true;
      }
    }
    return flag;
  };

  const dropDownSelectedOption = (type: NDCBulkEditFormFieldsTypes, value: string) => {
    return selectedOptionUtilityBultEdit(allFieldsOptions, type, value);
  };

  const handleFetchMultipleNdcsHistory = async () => {
    try {
      setIsHistoryLoading(true);

      // get all the selected ndcs
      const bulkSelectedNdcs: string[] = selectedNdcStrategyIndexesForEdit.map((index: number) => {
        const selectedNdcRowData = rowDataForSelectedNdcSectionByContractNumber(index);
        return selectedNdcRowData.NDC11 as string;
      });

      const payload: ndcHistoryRequestPayloadInterface = { NDC11: bulkSelectedNdcs };

      // fetch ndcs future history data
      const res = await factScreenServices.getNdcHistory(payload);
      setNdcHistoryData(res);
    } catch {
      toast.error("Selected NDCs history couldn't be fetched, please try again later");
    } finally {
      setIsHistoryLoading(false);
    }
  };

  useEffect(() => {
    if (ndcFormDropDownData)
      setAllFieldsOptions(convertNdcFormDataToAllOptionsBultEdit(ndcFormDropDownData));
  }, [ndcFormDropDownData]);

  useEffect(() => {
    // handle fetching ndc history
    handleFetchMultipleNdcsHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- initial load only
  }, []);

  return {
    userModulesRoles,
    ndcStrategyIndividualEditData,
    checkIfDropdownOptionDisabled,
    allDropdownOptions,
    handleStrategySelect,
    isAnyStrategySelected,
    handleUnselectStrategy,
    initialNdcStrategyIndividualEditData,
    formUpdateMethods,
    errorDetails,
    isNdcUpdating,
    maxDateFromGivenAndTodays,
    formFieldsArrayConverter,
    nonSelectedFields,
    dropDownSelectedOption,
    allOptions,
    allFieldsOptions,
    isUpdateDisable,
    handleFieldAdd,
    selectedOption,
    removeField,
    isHistoryLoading,
  };
};
